import { render } from "./RecipientsDropdown.vue?vue&type=template&id=330f2a47"
import script from "./RecipientsDropdown.vue?vue&type=script&lang=js"
export * from "./RecipientsDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__